/* 2024-03 switch from rwg.CSCS to Proj4js, this replaces CoordSystems.js
 * This initializes a rwg.proj{} object and provides an event
 * handler that displays coordinates in the status bar.
 */

import proj4 from '../../proj4js-2.10.0/'

import {register} from '../node_modules/ol/proj/proj4.js';
// import {get as getProjection, getTransform} from '../node_modules/ol/proj.js';
// import {get as getProjection, fromLonLat, toLonLat} from '../node_modules/ol/proj.js';
import {get as getProjection} from '../node_modules/ol/proj.js';

import dd2dms from './util/dd2dms.js'

export default function(config) {
  proj4.defs('EPSG:3737', "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192");
  proj4.defs('EPSG:3736', "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.0 +y_0=0.0 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192");
  proj4.defs('EPSG:3738', "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192")
  proj4.defs('EPSG:3739', "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192");
  proj4.defs('EPSG:2241', "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.999947 +x_0=200000 +y_0=0 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192");
  proj4.defs('EPSG:2242', "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.999947 +x_0=500000 +y_0=0 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192");

  proj4.defs('EPSG:32611', '+proj=utm +zone=11')
  proj4.defs('EPSG:32612', '+proj=utm +zone=12')
  proj4.defs('EPSG:32612', '+proj=utm +zone=12')
  proj4.defs('EPSG:32613', '+proj=utm +zone=13')
  proj4.defs('EPSG:32617', '+proj=utm +zone=17')

  register(proj4);

  // Proj4js does not support projection extents, but OpenLayers
  // requires extents to create default tile grids, so add them below.
  getProjection('EPSG:3736').setExtent([-971136.99, 178550.27, 964434.26, 1699151.37])
  getProjection('EPSG:3737').setExtent([520000, 320000, 2000000, 2200000])
  getProjection('EPSG:3738').setExtent([1330782.21, 178520.8, 3266177.52, 1678915.52])
  getProjection('EPSG:3739').setExtent([2000000, 300000, 3500000, 2200000])
  getProjection('EPSG:2241').setExtent([120000, 0, 1202000, 1268000])
  getProjection('EPSG:2242').setExtent([906000, 0, 2296000, 1750000])

  const projTitles = {  // used for labeling
    'EPSG:3736': "NAD83 Wyoming East (ftUS)",
    'EPSG:3737': "NAD83 Wyoming East Central USft",
    'EPSG:3738': "NAD83 Wyoming West Central USft",
    'EPSG:3739': "NAD83 Wyoming West  USft+",
    'EPSG:2241': "NAD83 Idaho East (ftUS)",
    'EPSG:2242': "NAD83 Idaho Central (ftUS)",
  }

/*
  Need:
  1. to_meters - use
      getProjection('EPSG:3739').getMetersPerUnit()  // works with utm & epsg:3857
      getProjection('EPSG:3739').getUnits()          // undefined for utm

  window.getProjection = getProjection
  window.getProjection('EPSG:3739').getCode()

*/

  const mapSRID = config.mapCoordSys || config.olProjection.code
  const dataSRID = config.dataCoordSys || mapSRID
  const utmSRID = `EPSG:326${config.utm_zone}` || null
  const utmTitle = utmSRID ? `NAD83 UTM Zone ${config.utm_zone}` : null
  const spSRID = config.statePlane || null
  const spTitle = projTitles[spSRID]
  let cartesianSRID  // best available cartesian coord system, used for distance calculations
  if (spSRID) {
    cartesianSRID = spSRID;
  } else if (utmSRID) {
    cartesianSRID = utmSRID;
  } else {
    cartesianSRID = null;
  }

  const llElement = document.getElementById('coordsLL') ? document.getElementById('coordsLL') : null;
  const utmElement = document.getElementById('coordsUTM') && utmSRID ? document.getElementById('coordsUTM') : null;

  const utmTtileElement = document.getElementById('coordsUTM_label')
  if (utmTtileElement && utmTitle) {
    utmTtileElement.innerHTML = utmTitle
  }

  // Private function displays mouse position coordinates in status bar in lat/lon and UTM
  function display(evt) {
    if (evt.dragging) return

    let ll = proj4(mapSRID, 'EPSG:4326', evt.coordinate)
    let utm = proj4('EPSG:4326', utmSRID, ll).map(e => Math.round(e))

    if (llElement && llElement.offsetParent) {      // display long/lat
      llElement.innerHTML = `
        <table cellpadding="0" cellspacing="0">
          <tr><td>Lon:&nbsp;${dd2dms(ll[0])}</td><td>&nbsp;Lat:&nbsp;${dd2dms(ll[1])}</td></tr>
          <tr><td>Lon:&nbsp;${ll[0].toFixed(5)}°</td><td>&nbsp;Lat:&nbsp;${ll[1].toFixed(5)}°</td></tr>
        </table>`;
    }

    if (utmElement && utmElement.offsetParent) {     // display UTM
      utmElement.innerHTML = 'X: ' + utm[0] + ' Y: ' + utm[1]
    }
  }

  return {
    // proj4: proj4, // the Proj4js transformation function
    transform : (from, to, coords) => from === to ? coords : proj4(from, to, coords),  // avoid proj4 when unnecessary
    display: display, // mouse move event handler
    mapSRID: mapSRID,
    dataSRID: dataSRID,
    spSRID: spSRID,
    spTitle: spTitle,
    utmSRID: utmSRID,
    utmTitle: utmTitle,
    cartesianSRID: cartesianSRID,
    cartesianMetersPerUnit: getProjection(cartesianSRID).getMetersPerUnit() || 1,
  }

}
